import React from 'react';

const ProposalList = ({
    initialdata,
    sectionLabel,
    proposalData
}) => {
    return (
        <>
            {
                sectionLabel && <div className="section-header">
                    {
                        sectionLabel
                    }
                </div>
            }
            {
                initialdata && initialdata.map((item, i) => {
                    return (
                        item.show && typeof item.value !== 'object' && item.value !== null &&
                        <div className={"list_proposal " +(((item.key === "addressLine1") || (item.key === "addressLine2")) ? "address-field":"") } key={i}>
                            <div className="label"> {item.name}</div>
                            <div className="value"> {item.value === 0 ? item.value + "" : item.value}</div>
                            {item.key === "proposalNumber" && 
                            <>
                                 <p className={`${proposalData.disableProposalStatus ? "disabled" : "enabled"}`}>{`Status: ${proposalData.disableProposalStatus? "DISABLED": "ENABLED"}`}</p>
                                 <p className={`${proposalData.disableProposalStatus ? "disabled" : "enabled"}`}>{`Remarks: ${proposalData.proposalRemarks}`}</p>
                            </>
                                
                            }
                        </div>
                    )
                })
            }
        </>
    )
}

export default ProposalList;
